(function () {
  'use strict';

  function ensurePagination(el) {
    var ul = el.querySelector('.ingredients__pagination');
    if (ul) return ul;

    ul = document.createElement('ul');
    ul.className = 'ingredients__pagination';
    ul.setAttribute('aria-label', 'Ingredient pagination');

    var arrows = el.querySelector('.ingredients__arrows');
    if (arrows) {
      var nextBtn = arrows.querySelector('.ingredients__arrow--next');
      if (nextBtn) {
        arrows.insertBefore(ul, nextBtn);
      } else {
        arrows.appendChild(ul);
      }
    } else {
      el.appendChild(ul);
    }
    return ul;
  }

  function buildPagination(splide, el) {
    var ul = ensurePagination(el);
    if (!ul) return;

    var length = (typeof splide.length === 'number' && splide.length > 0)
      ? splide.length
      : el.querySelectorAll('.splide__slide').length;

    var activeIndex = typeof splide.index === 'number' ? splide.index : 0;

    while (ul.firstChild) ul.removeChild(ul.firstChild);

    if (length <= 1) {
      ul.hidden = true;
      return;
    }
    ul.hidden = false;

    for (var i = 0; i < length; i++) {
      (function (idx) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ingredients__page';
        btn.setAttribute('aria-label', 'Go to ingredient ' + (idx + 1));
        if (idx === activeIndex) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          splide.go(idx);
        });
        li.appendChild(btn);
        ul.appendChild(li);
      })(i);
    }
  }

  function updateActiveDot(el, index) {
    var btns = el.querySelectorAll('.ingredients__page');
    btns.forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
    });
  }

  /* Skincare: the row keeps the height of the product's tallest card, so it
     does not grow or shrink as cards with more or less copy open. Each
     card's white panel keeps its open width while closed, so every one can
     be measured where it is; the list gets the tallest as its min-height
     and the cards stretch to it. Measured again when the layout changes
     size and once the web font has loaded. */
  function holdHeight(el) {
    var list = el.querySelector('.splide__list');
    var slides = el.querySelectorAll('.ingredients__slide');
    if (!list || !slides.length) return;

    var frame = null;

    function measure() {
      frame = null;
      if (!el.isConnected) return;
      var tallest = 0;
      slides.forEach(function (slide) {
        var panel = slide.querySelector('.ingredients__open');
        var card = panel && panel.querySelector('.ingredients__card');
        if (!card) return;
        var style = window.getComputedStyle(panel);
        var height = card.scrollHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        if (height > tallest) tallest = height;
      });
      list.style.minHeight = tallest ? Math.ceil(tallest) + 'px' : '';
    }

    function schedule() {
      if (frame === null) frame = window.requestAnimationFrame(measure);
    }

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        if (!el.isConnected) {
          observer.disconnect();
          return;
        }
        schedule();
      });
      observer.observe(el);
    } else {
      window.addEventListener('resize', schedule);
    }
  }

  function setup(el) {
    if (el._ingredientsInit) return;
    if (typeof window.Splide !== 'function') return;

    el._ingredientsInit = true;

    var slider = el.querySelector('.ingredients__slider[data-splide]');
    if (!slider) return;

    var slideCount = el.querySelectorAll('.splide__slide').length;
    var initialSlide = el.querySelector('.ingredients__slide.is-initial');
    if (initialSlide) initialSlide.classList.remove('is-initial');

    if (slideCount <= 1) {
      var only = el.querySelector('.splide__slide');
      if (only) only.classList.add('is-active');
      return;
    }

    try {
      var splide = new window.Splide(slider);

      splide.on('mounted', function () {
        buildPagination(splide, el);
      });
      splide.on('updated resized', function () {
        buildPagination(splide, el);
      });
      splide.on('move', function (newIndex) {
        updateActiveDot(el, newIndex);
      });

      el._splide = splide.mount();

      if (el.classList.contains('ingredients--skincare')) holdHeight(el);

      /* Click on a closed slide → navigate to it. The closed-state element
         is a native <button>, so keyboard activation works for free; CSS
         pointer-events on the active slide's closed layer prevents the
         already-open slide from firing this. */
      el.querySelectorAll('.ingredients__slide').forEach(function (slide) {
        var btn = slide.querySelector('[data-ingredients-open]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var idx = parseInt(slide.getAttribute('data-index'), 10);
          if (!isNaN(idx) && splide && typeof splide.go === 'function') {
            splide.go(idx);
          }
        });
      });
    } catch (err) {
      console.error('Splide init failed for ingredients:', err);
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-ingredients]')) setup(root);
    root.querySelectorAll('[data-ingredients]').forEach(setup);
  }

  if (typeof window.Splide === 'function') {
    init();
  } else {
    document.addEventListener('splide:ready', function () { init(); }, { once: true });
  }

  /* Re-initialise when the section is re-rendered. The Theme Editor does
     this on every edit, and so does `shopify theme dev` hot reload — the
     swapped-in markup has no listeners and the browser will not re-run an
     external script it has already executed, so without this the slider
     silently dies until a full page reload. */
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (typeof window.Splide === 'function') {
      init(target);
    } else {
      document.addEventListener('splide:ready', function () { init(target); }, { once: true });
    }
  });
})();
